export const isProduct = window._$isProduct

export const $UrlApipath = window._$UrlApipath
export const $Urlpath = window._$Urlpath

export const $Path = window._$Path

export const Permission = {
  //查看
  See: 1,
  //添加
  Add: 2,
  //修改
  Update: 4,
  //删除
  Delete: 8,
  //手续费减免
  NoFee:1048576,
  //806355022
  //修改状态
  UpdateStatus: 16,
  //审核
  Audit: 32,
  //分配跟踪人 2^30
  DistributionChannel: 1073741824,

  //进入客户账户 2^29
  ToCustomerAccounts: 536870912,

  //快速扫描收货
  FastScanning: 16,

  //快速扫描收货
  Scanandcollectgoods: 32,

  //海运扫描收货
  SeaborneScanning: 64,

  //无单收货扣费
  NoSingleChargeDeduction: 128,

  //平邮收货扣费
  DeductionsForCollectingGoodsByOrdinaryMail: 256,



  //付费
  Pay: 128,
  //确认订单付款
  ConfirmationOfOrderPayment: 256,
  //完结
  End: 512,
  //作废
  ToVoid: 1024,
  //确认坏账
  ConfirmationOfBadDebts: 2048,

  //修改信用额度/保证金/币种
  Modify_the_credit: 268435456,

//领取
Receive: 2048,


   //其他额外操作(设置优先级,流转,回复,完结)
Other_extra_operations: 4096,



  //更新Shopify
 UpdateShopify :  2048,


  //上传
 Upload :  4096,


 //发布
  Send :  2048,

//隐藏显示库位
HiddenLocation:32
}


export const Modulel = {
  // //客户免手续费
  // UserView2:8653,
  //用户查看
  UserView: 1,
  //仓库查看
  WarehouseView: 2,
  //权限管理
  RightsManage: 3,
  //角色管理
  RoleManage: 4,

  UserManage: 5,

  //部门
  DepartmentManage: 6,

  //客户列表
  CustomerManage: 7,

  //地区
  RegionManage: 8,

  //渠道管理
  ChannelInfoManage: 9,

  //渠道套餐
  ChannelMealManage: 10,
  //渠道类型
  ChannelTypeManage: 11,
  //下家公司信息
  NextCompanyManage: 12,
  //渠道附加费
  ChannelSurchargeManage: 13,

  //仓储设置
  WarehouseManage: 14,

  //库位信息
  WareHousesLocationManage: 16,

  WareHousesPathManage: 15,

  OpentorFeeDiscountManage: 17,

  OrderOpentorFeeManage: 18,

  //发件人管理
  SendAddressManage: 19,


  //仓储上架费用
  UpFeeManage: 20,

  //仓储上架费用折扣
  UpFeesDiscountManage: 21,


  //仓储卡板费用
  PalletFeeManage: 22,

  //仓储卡板费用折扣
  PalletFeeDiscountManage: 23,

  //渠道订单项配置
  ChannelItemSetupManage: 24,

  //客户开通仓储
  CustomerWhouseManage: 25,


  //渠道预报方法配置
  ChannelApiTypeManage: 26,

  //订单列表
  OrderManage: 27,

  //收货扣费操作
  BuckleCharge: 28,
  //包材
  PackInfoManage: 29,


  //银行信息
  BankInfoManage: 30,

  //汇率设置
  ExchangeRateManage: 31,
  //客户充值
  AccountInComeManage: 32,
  //账单管理
  InvoiceManage: 33,
  //付款明细
  PaidDetailManage: 34,



  //公司设置
  CompanyInfoManage: 5001,

  //邮件设置
  EmailConfigManage: 5002,

  //颜色标记
  ColorMarkManage: 5003,

  //增值服务
  AddServiceManage: 5004,



  ProductTypeManage: 6001,

  ProductManage: 6002,

  SkuMappingManage: 6003,

  SupplierManage: 6004,

  ASN_PurchasesManage: 6005,



  InventoryCustomerManage: 6006,

  InventoryTotalManage: 6007,

  InventoryManage: 6008,

  ASN_ReceivesManage: 6009,

  InventoryInAndOutManage: 6010,

  PickUpBatchManage: 6011,

  DeliverBacthManage: 6012,

  //打印标签
  PrintLabel: 6013,

  //取消订单
  CancelOrder: 6014,

  //撤销收货
  CancelReceipt: 6015,

  //运费查询
  FreightInquiries: 6016,


  //工单类型
  QuestionTypeManage: 6017,



  //工单类型
  QuestionManage: 6018,


  //挂号费折扣
  RegistrationDiscountManage : 6019,



        //修改密码
  UpdatePassword : 1001,

 //上传AfterShip
 UploadAfterShip  : 6020,



  CharacterParentManage: 10000,

  Sys_NewsTypeManage  : 1002,

  Sys_NewManage: 1003,

  ShopProductManage  : 6021,

  PopularizeManage :12001,


  GeneralizeRateManage :12002,


  CommissionManage : 12003,


  GeneralizeManage : 12004,

  PurchaseRequestManage: 13001,

  EmailMessageManage: 35,

  InventoryCheckManage: 6022,
  MyShoppingMall:14001,

  ProductMall:14003,

}


import {
  userRequest
} from '../request/user'



//判断权限是否存在 同步查询 刷新页面会查询完才显示
export function IsRights(Modulel, Permission) {

  if (window.rootVue) {
    if (!window.rootVue.$store.state.UserRights.Rights || !window.ISGETRights) {
      userRequest.GetUserRights(function (d) {
        if (!d.Message) {
          window.ISGETRights = true;
          window.rootVue.$store.state.UserRights.Rights = d.Rights;
          window.rootVue.$store.state.UserRights.UserContext = d.UserContext;
          window.rootVue.$store.state.UserRights.PublicDatas = d.PublicDatas;
        }
      }, [])
    }

    var UserRights = window.rootVue.$store.state.UserRights.Rights
  
    var l1 = [];
    var i = 1;

    while (true) {
      if (i <= Permission && ((i | Permission) == Permission)) {
        l1.push(i);
        if (i == Permission) {
          break;
        }
      } else if (i > Permission) {
        break;
      }
      i = i * 2;
    }

    for (var a of UserRights) {
      if (a.ModuleID == Modulel) {
        for (var c of l1) {
          if ((a.Permission | c) == a.Permission) {
            //console.log("IsRights Modulel :" + Modulel + " Permission:" + Permission + " return " + true)
            return true;
          }
        }
      }
    }
    //console.log("IsRights Modulel :" + Modulel + " Permission:" + Permission + " return " + false)
    return false;
  }
  //console.log("IsRights Modulel :" + Modulel + " Permission:" + Permission + " return " + false)
  return false;
}

export function FieldData2List(FieldData) {
  var dfs = []
  for (var f of FieldData) {
    if (f.type == "Col") {
      for (var c of f.colFields) {
        if (!c.isNotField) {
          dfs.push(c)
        }
      }

    } else {
      dfs.push(f)
    }
  }
  return dfs;
}


//根据配置生成组件所需要的 实体类
export function ToComponentData(FieldData) {
  var d = {}
  var dfs = FieldData2List(FieldData)

  for (var e in dfs) {

    var f = dfs[e];

    if (f.type == "Button") {
      continue;
    }

    var isb = f.initValue;
    var t = f.type;

    d[f.field] = f
    var c = d[f.field];
    c.error = '';

    if (t == 'String') {
      if (isb) {
        c.value = isb
      } else {
        c.value = '';
      }
    } else if (t == 'Int') {
      if (isb) {
        c.value = isb
      } else {
        c.value = '';
      }
    } else {
      c.value = isb
    }
  }
  return d;
}

import '../lf'
export function ToSubmitData(ComponentData) {
  var d = {}
  for (var e in ComponentData) {
    var f = ComponentData[e];
    d[e] = f.value;
  }
  return d;
}


//生成表单 数据实体类
export function ToSubmitEntity(Entity, FieldData) {
  var d = {}
  var dfs = FieldData2List(FieldData)

  for (var e in Entity) {
    var f = Entity[e];
    if (dfs) {
      var ws = new window.$LQ(dfs).Where(function (a) { return a.field == e }).First()

      if (ws && ws.toFieldData) {
        d[e] = ws.toFieldData(ws, Entity)
        continue;
      }


    }
    d[e] = f;
  }
  return d;
}


import {
  ObjectCheck
} from '../lf'

//检测Config 数据是否准确
export function CheckByConfig(config, ValueObj) {
  var d = true;
  for (var e of config) {
    if (e.j) {
      var check = ObjectCheck(e.j, ValueObj[e.field].value)
      if (!check.IsCheck) {
        d = false;
        ValueObj[e.field].error = check.error
      } else {
        ValueObj[e.field].error = '';
      }
    }
  }
  return d;
}

//检测Entity 数据是否准确
export function CheckByEntity(entity, FieldData) {
  var d = true;
  var ds = [];
  var dfs = FieldData2List(FieldData)

  for (var e of dfs) {
    if (e.j) {
      var check = ObjectCheck(e.j, entity[e.field])
      if (!check.IsCheck) {
        d = false;
        e.error = check.error
        ds.push(check.error)

      } else {
        e.error = '';
      }
    }
  }

  if (!d) {
    window.rootVue.$message.error(ds[0])
  }

  return d;
}


//克隆
export function Clone(origin) {
  let originProto = Object.getPrototypeOf(origin);
  return Object.assign(Object.create(originProto), origin);
}


//去掉不要的行
//tabelsourse :tabel 值，   tablehidencolumn：需要隐藏的列名数组
export function TableHiddenbing(tabelsourse,tablehidencolumn) {


  for (var os in tabelsourse.TableColumns) {


    if (tabelsourse.TableColumns[os].field)
    {
      if (tablehidencolumn.indexOf(tabelsourse.TableColumns[os].field) > -1)
      {

        // if (tabelsourse.TableColumns[os].hasOwnProperty("IsNotShow")) {
        //   tabelsourse.TableColumns[os].IsNotShow = true;
        // }
        // else {

          tabelsourse.TableColumns[os].IsNotShow = true;
        // }


    }


    }
  }

  return tabelsourse;
}





import store, { UserRights } from '@/model/store'

export function toSelect(value, forSelectStoreName) {
  var obj = store.state[forSelectStoreName]
  for (var i in obj) {

    if (obj[i]['Value'] == value) {
      return obj[i]['Text']
    }
  }
  return value;
}



/**
    * 配置参考 http://element-cn.eleme.io/#/zh-CN/component/table
    * Table Methods
    * clearSelection 用于多选表格，清空用户的选择，当使用 reserve-selection 功能的时候，可能会需要使用此方法 参数:selection
    * toggleRowSelection 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）	参数:row, selected
    * toggleRowExpansion 用于可展开表格，切换某一行的展开状态，如果使用了第二个参数，则是设置这一行展开与否（expanded 为 true 则展开）	参数:row, expanded
    * setCurrentRow 用于单选表格，设定某一行为选中行，如果调用时不加参数，则会取消目前高亮行的选中状态。 参数:row
    * clearSort  用于清空排序条件，数据会恢复成未排序的状态
    * clearFilter 用于清空过滤条件，数据会恢复成未过滤的状态
    * Table Slot
    * append 插入至表格最后一行之后的内容，如果需要对表格的内容进行无限滚动操作，可能需要用到这个 slot。若表格有合计行，该 slot 会位于合计行之上。
    */

export const TableDefaultConfig = {


  //表格高度，单位 px，设置后，如果表格内容大于此值，会固定表头
  Height: undefined,
  //表格高度，单位 px，设置后，如果表格内容大于此值，会固定表头
  MaxHeight: undefined,
  //是否显示间隔斑马纹
  IsStripe: false,
  //是否显示纵向边框
  IsBorder: true,
  //表格尺寸，可选值为 large、small、default 或者不填
  Size: "default",
  //列的宽度是否自撑开
  IsFit: true,
  //是否显示表头
  IsShowHeader: true,
  //是否支持高亮选中的行，即单选
  IsHighlightCurrentRow: false,
  //当前行的 key，只写属性
  CurrentRowKey: null,
  // 行的 className 的回调方法，传入参数：row：当前行数据  index：当前行的索引 Function({row, rowIndex})/String
  RowClassName: null,
  //行的 style 的回调方法，也可以使用一个固定的 Object 为所有行设置一样的 Style。 Function({row, rowIndex})/Object
  RowStyle: null,
  //单元格的 className 的回调方法，也可以使用字符串为所有单元格设置一个固定的 className。 Function({row, column, rowIndex, columnIndex})/String
  CellClassName: null,
  //单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有单元格设置一样的 Style。Function({row, rowIndex, rowIndex, columnIndex})/Object
  CellStyle: null,
  //表头行的 className 的回调方法，也可以使用字符串为所有表头行设置一个固定的 className。Function({row, rowIndex})/String
  HeaderRowClassName: null,
  //表头行的 style 的回调方法，也可以使用一个固定的 Object 为所有表头行设置一样的 Style。 Function({row, rowIndex})/Object
  HeaderRowStyle: null,
  //表头单元格的 className 的回调方法，也可以使用字符串为所有表头单元格设置一个固定的 className。Function({row, column, rowIndex, columnIndex})/String
  HeaderCellClassName: null,
  //表头单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有表头单元格设置一样的 Style。 Function({row, rowIndex, rowIndex, columnIndex})/Object
  HeaderCellStyle: null,
  //行数据的 Key，用来优化 Table 的渲染；在使用 reserve-selection 功能的情况下，该属性是必填的。类型为 String 时，支持多层访问：user.info.id，但不支持 user.info[0].id，此种情况请使用 Function。Function(row)/String
  RowKey: null,
  //空数据时显示的文本内容，也可以通过 slot="empty" 设置
  EmptyText: "null",
  //是否默认展开所有行，当 Table 中存在 type="expand" 的 Column 的时候有效
  IsDefaultExpandAll: false,
  //可以通过该属性设置 Table 目前的展开行，需要设置 row-key 属性才能使用，该属性为展开行的 keys 数组。 Array
  ExpandRowKeys: null,
  //默认的排序列的prop和顺序。它的prop属性指定默认的排序的列，order指定默认排序的顺序
  //DefaultSort:"{prop: 'ID', order: 'descending'}",
  //tooltip effect 属性
  TooltipEffect: null,

  //是否在表尾显示合计行 Boolean
  IsShowSummary: false,
  //合计行第一列的文本
  SumText: null,

  //自定义的合计计算方法 Function({ columns, data })
  SummaryMethod: null,
  //合并行或列的计算方法 Function({ row, column, rowIndex, columnIndex })
  SpanMethod: null,
  //当用户手动勾选数据行的 Checkbox 时触发的事件 selection：已选项数据    row：刚选择的项数据
  OnSelect: null,
  //在多选模式下有效，点击全选时触发   selection：已选项数据
  OnSelectAll: null,
  //在多选模式下有效，只要选中项发生变化时就会触发 selection：已选项数据
  OnSelectionChange: null,
  //当单元格 hover 进入时会触发该事件  row, column, cell, event
  OnCellMouseEnter: null,

  //当单元格 hover 退出时会触发该事件  row, column, cell, event
  OnCellMouseLeave: null,
  //当某个单元格被点击时会触发该事件 row, column, cell, event
  OnCellClick: null,
  //当某个单元格被双击击时会触发该事件  row, column, cell, event
  OnCellDBlclick: null,
  //当某一行被点击时会触发该事件  row, event, column
  OnRowClick: null,
  //当某一行被鼠标右键点击时会触发该事件  row, event
  OnRowContextmenu: null,
  //当某一行被双击时会触发该事件 row, event
  OnRowDBlclick: null,
  //当某一列的表头被点击时会触发该事件  column,  event
  OnHeaderClick: null,
  //当表格的排序条件发生变化的时候会触发该事件  { column, prop, order }
  OnSortChange: null,
  //当表格的筛选条件发生变化的时候会触发该事件，参数的值是一个对象，对象的 key 是 column 的 columnKey，对应的 value 为用户选择的筛选条件的数组。 filters
  OnFilterChange: null,
  //当表格的当前行发生变化的时候会触发该事件，如果要高亮当前行，请打开表格的 highlight-current-row 属性	   currentRow：当前高亮行的数据   oldCurrentRow：上一次高亮的数据
  OnCurrentChange: null,
  //当拖动表头改变了列的宽度的时候会触发该事件 newWidth, oldWidth, column, event
  OnHeaderDragend: null,
  //当用户对某一行展开或者关闭的时候会触发该事件 row, expandedRows
  OnExpandChange: null
}



export const TableColumnDefaultConfig = {
  //对应列的类型。如果设置了 selection 则显示多选框；如果设置了 index 则显示该行的索引（从 1 开始计算）；如果设置了 expand 则显示为一个可展开的按钮 string 可选值 selection/index/expand
  //注: 因为和组件名称有冲突 所以更改为 ctype
  CType: null,
  //如果设置了 type=index，可以通过传递 index 属性来自定义索引 string, Function(index)
  Index: null,
  //column 的 key，如果需要使用 filter-change 事件，则需要此属性标识是哪个 column 的筛选条件  string
  ColumnKey: null,

  //显示的标题 string (取消由nickname来代替)
  //Label: null,
  //对应列内容的字段名，也可以使用 property 属性 string (取消由field来代替)
  //Prop: null,

  //对应列的宽度  string
  Width: null,
  //对应列的最小宽度，与 width 的区别是 width 是固定的，min-width 会把剩余宽度按比例分配给设置了 min-width 的列  string
  MinWidth: null,
  //列是否固定在左侧或者右侧，true 表示固定在左侧  string, boolean    可选值  true, left, right
  Fixed: false,
  //列标题 Label 区域渲染使用的 Function  Function(h, { column, $index })
  RenderHeader: null,
  //对应列是否可以排序，如果设置为 'custom'，则代表用户希望远程排序，需要监听 Table 的 sort-change 事件 boolean, string      可选值  true, false, 'custom'
  Sortable: null,
  //对数据进行排序的时候使用的方法，仅当 sortable 设置为 true 的时候有效，需返回一个数字，和 Array.sort 表现一致  Function(a, b)
  SortMethod: null,
  //指定数据按照哪个属性进行排序，仅当 sortable 设置为 true 且没有设置 sort-method 的时候有效。如果 sort-by 为数组，则先按照第 1 个属性排序，如果第 1 个相等，再按照第 2 个排序，以此类推。String/Array/Function(row, index)
  SortBy: null,
  //对应列是否可以通过拖动改变宽度（需要在 el-table 上设置 border 属性为真）     boolean
  IsResizable: true,
  //用来格式化内容 Function(row, column, cellValue)
  Formatter: null,
  //当内容过长被隐藏时显示 tooltip
  IsShowOverflowTooltip: false,
  //对齐方式 String 可选值 left/center/right
  Align: 'left',
  //表头对齐方式，若不设置该项，则使用表格的对齐方式  String 可选值 left/center/right
  HeaderAlign: "left",
  //列的 className  string
  ClassName: null,
  //当前列标题的自定义类名 string
  LabelClassName: '',
  //仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选 Function(row, index)
  Selectable: null,
  //仅对 type=selection 的列有效，类型为 Boolean，为 true 则代表会保留之前数据的选项，需要配合 Table 的 clearSelection 方法使用。 Boolean
  ReserveSelection: false,
  //数据过滤的选项，数组格式，数组中的元素需要有 text 和 value 属性。 Array[{ text, value }]
  Filters: null,
  //过滤弹出框的定位 String 与 Tooltip 的 placement 属性相同
  FilterPlacement: null,
  //数据过滤的选项是否多选  Boolean
  IsFilterMultiple: true,

  //数据过滤使用的方法，如果是多选的筛选项，对每一条数据会执行多次，任意一次返回 true 就会显示。Function(value, row)
  FilterMethod: null,
  //选中的数据过滤项，如果需要自定义表头过滤的渲染方式，可能会需要此属性。 Array
  FilteredValue: null,

}





export function TableConfigGenerate(config) {
  var f = Clone(TableDefaultConfig);
  for (var i in config) {
    if (i == "TableColumns") {
      var tcs = []
      for (var c of config[i]) {
        var fc = Clone(TableColumnDefaultConfig);
        for (var t in c) {
          fc[t] = c[t]
        }
        tcs.push(fc)
        config["TableColumns"] = tcs;
      }
    }
    f[i] = config[i]
  }
  return f;
}



// WEBPACK FOOTER //
// ./src/config/config.js